import { _Article_liquid } from "../../@types/shopify";

const initArticleCard = ($el: HTMLElement, $refs: Record<string, HTMLElement>, articleHandle: string) => {
  const random_id = utils.shortUUID();

  const article =
    _articles[articleHandle] ||
    utils.JSONParse<_Article_liquid>(document.querySelector(`[data-article-data="${articleHandle}"]`)?.innerHTML);

  const state = window.Alpine.reactive({
    random_id,
    hydrated: true,
    ...(article ?? {}),
    url: article?.url ?? `/blogs/${article?.handle}`,
  });

  const getDynamicValue = (content: string) => {
    return utils.getBracketInputDynamicValue(content, state);
  };

  const getDynamicValueWithFallbacks = (content: string) => {
    return content.split(",")?.reduce((acc, item) => {
      acc ||= utils.getBracketInputDynamicValue(item.trim(), state);
      return acc;
    }, "");
  };

  const getDynamicText = (content: string) => {
    return utils.getBracketInputDynamicPluralizedText(content, state);
  };

  const getContentLabels = (key: string) => {
    const labels = key.split(".").reduce<any>((acc, selector) => {
      if (!selector || acc === undefined || acc === null) return acc || "";

      if (acc && selector in acc) {
        return acc[selector];
      }
      return "";
    }, state);

    if (Array.isArray(labels)) {
      return labels.filter(Boolean);
    }
    return [labels].filter(Boolean);
  };

  return {
    card: state,
    $el,
    getDynamicValue,
    getDynamicValueWithFallbacks,
    getDynamicText,
    getContentLabels,
  };
};

const fallbackHydrationQueue = new Set<HTMLElement>();

const hydrateArticleCardContent = ($el: HTMLElement) => {
  const card_handle = $el.getAttribute(`data-card-handle`);
  const article_handle = $el.getAttribute(`data-article-handle`);
  const article_id = $el.getAttribute(`data-article-id`);
  const classes = utils.JSONParse<string[]>($el.getAttribute(`data-card-classes`) ?? "[]");

  const node = document.querySelector(`[data-article-card='${card_handle}']`)?.cloneNode(true) as HTMLElement;

  if (!node) {
    fallbackHydrationQueue.add($el);
    return;
  }

  node?.removeAttribute(`data-article-card`);
  node?.setAttribute("data-article-handle", article_handle);
  node?.setAttribute("data-article-id", article_id);
  node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
    el.remove();
  });

  node.classList.add(...classes);
  $el.parentNode?.replaceChild(node, $el);
};

document.addEventListener("modalsLoaded", () => {
  fallbackHydrationQueue.forEach((el) => {
    hydrateArticleCardContent(el);
  });
  fallbackHydrationQueue.clear();
});

const observer = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting && entry.target instanceof HTMLElement) {
        hydrateArticleCardContent(entry.target);
        observer.unobserve(entry.target);
      }
    }
  },
  { rootMargin: "300px 300px 300px 300px" }
);

const hydrateArticleCard = ($el: HTMLElement) => {
  if ($el.hasAttribute("data-intersected")) {
    hydrateArticleCardContent($el);
    return;
  }

  observer.observe($el);
};

export type InitArticleCard = typeof initArticleCard;
export type HydrateArticleCard = typeof hydrateArticleCard;

window._sections["initArticleCard"] = initArticleCard;
window._sections["hydrateArticleCard"] = hydrateArticleCard;
